export default {
  namespaced: true,
  state: {
    event_id: {
      // 估价id
      evaluation: 'click_evaluation',
      // 立即估价id
      qucikEvaluation: 'click_qucikEvaluation',
      // 提交订单id
      placeOrder: 'click_placeOrder',
      // 马上换钱id
      quickRecycle: 'click_quickRecycle',
      // 百度广告投放id
      hsbbaidusem: 'click_hsbbaidusem'
    }
  },
  mutations: {
    reportHandle (state, data = {}) {
      try {
        /* eslint-disable no-undef */
        ReportPoint.onBtn({
          event_id: state.event_id[data.event],
          // 事件参数
          event_custom: data.event_custom || {},
          // 自定义参数(没有值的话传空值)
          custom: data.custom || {}
        });
      } catch (error) {}
    }
  }
};



// WEBPACK FOOTER //
// ./src/projects/hsbpc/store/module/report.js